import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';
import { CvConfigurationService } from '../../../../../reusables/services/cv-configuration.service';

@Component({
    selector: 'cv-actions-cell-renderer',
    templateUrl: './actions-cell-renderer.component.html',
    styleUrls: ['./actions-cell-renderer.component.scss']
})
export class ActionsCellRendererComponent implements AgRendererComponent {
    params: ICellRendererParams;
    deleteTooltip: string;
    hasWriteAccess: boolean;

    constructor(
        public config: CvConfigurationService,
    ) { }

    agInit(params: ICellRendererParams) {
        this.params = params;
        this.deleteTooltip = this.params.context.contextUtil.getDeleteTooltip();
        this.hasWriteAccess = this.params.context.contextUtil.hasWriteAccess(this.params.data);
    }

    refresh(params: ICellRendererParams) {
        this.params = params;
        this.hasWriteAccess = this.params.context.contextUtil.hasWriteAccess(this.params.data);
        return true;
    }

    contextMenuClick(e: MouseEvent) {
        this.params.api['contextMenuFactory'].showMenu(this.params.node, this.params.columnApi.getColumn("Actions"), this.params.value, e);
    }

    deleteButtonClick(e: MouseEvent) {
        this.params.context.contextUtil.deleteDashboard();
    }
}
